import BaseModel from "./BaseModel";

class UserModel extends BaseModel {
  id: number = 0;
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  phone: string = "";
  password: string = "";
  passwordConfirm: string = "";
  changePassword: boolean = false;
  blocked: boolean = false;
  active: boolean = true;
  _permissions: object = {};
  organization: string = "";

  constructor(options?: object) {
    super();
    this.setData(options);
  }

  set fullname(value) {
    this.firstName = value
      .split(" ")
      .slice(0, -1)
      .join(" ");
    this.lastName = value.split(" ").pop() || "";
  }

  get fullname(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  set permissions(value) {
    this._permissions = value || {};
  }

  get permissions(): object {
    return this._permissions;
  }

  isUser(): boolean {
    return !!this.id;
  }

  hasPermission(permission: string): boolean {
    return (this.permissions as any)[permission] === true;
  }
}

export default UserModel;
